import { API_BASE_URL } from '../utils/api';

async function parseJson(res) {
  const text = await res.text();
  try { return JSON.parse(text); } catch { return null; }
}

/**
 * POST /api/joi/session/start
 * @param {{ playerKinkIds: string[], playerRealItemIds: string[], targetRating?: string }} body
 */
export async function startJoiSession(body) {
  const res = await fetch(`${API_BASE_URL}/api/joi/session/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data?.message || 'joi session start failed');
  return data;
}

/**
 * POST /api/joi/session/next
 * @param {{ sessionState: object, playerAction?: { type: string, value?: string } }} body
 */
export async function nextJoiNode(body) {
  const res = await fetch(`${API_BASE_URL}/api/joi/session/next`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data?.message || 'joi session next failed');
  return data;
}
